import styled, { css } from "styled-components";

interface IBundleCardContainerProps {
  themeBuyButtonsOption: string;
  customButtonColor: string;
}

export const BundleCardContainer = styled.div<IBundleCardContainerProps>`
  width: 350px;
  display: flex;
  background: #fff;
  align-items: center;
  border-radius: 13px;
  flex-direction: column;
  box-shadow: 1px 30px 60px rgba(0, 0, 0, 0.08);

  a {
    width: 100%;
  }

  .bundleCardTitle {
    width: 100%;
    color: #fff;
    font-size: 20px;
    padding: 20px 35px;
    text-align: center;
    margin-bottom: 5px;
    text-transform: uppercase;
    border-radius: 13px 13px 0 0;
    color: ${({ theme }) => theme.colors.textColor};
    background: ${({ theme }) => theme.colors.enrollmentCardTitleBackground};
  }

  .plan-card-body {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: column;
    padding: 40px 35px 35px;
    border-radius: 0 0 13px 13px;

    h2 {
      font-size: 26px;
      font-weight: 500;
      text-align: center;
      margin-bottom: 28px;
      text-transform: uppercase;
    }

    & > span {
      color: #999;
      font-size: 17px;
      font-weight: 300;
      margin-bottom: 10px;
      text-transform: lowercase;
    }

    .buy-btn {
      width: 100%;
      font-size: 1rem;
      margin: 40px 0 0;
      height: fit-content;
      border: unset;
      color: ${({ theme }) => theme.colors.btnTextColor} !important;
      background-color: ${({ theme }) => theme.colors.primary} !important;
    }

    ${({ themeBuyButtonsOption, customButtonColor, theme }) =>
      themeBuyButtonsOption !== "automatic" &&
      css`
        .buy-btn {
          background-color: ${customButtonColor} !important;
          border-color: ${customButtonColor} !important;
          color: ${theme.colors.btnTextColor} !important;

          &:hover {
            opacity: 0.8;
            color: ${({ theme }) => theme.colors.btnTextColor} !important;
          }
        }
      `}

    h4.private-warn {
      margin: 30px 0 0;
      text-align: center;
      ${({ theme }) => theme.mode === "dark" && "color: #fff;"}
    }
  }

  @media screen and (max-width: 858px) {
    width: 300px;
  }

  @media screen and (max-width: 720px) {
    width: 100%;
  }
`;
